import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { SettingsIcon } from "../../../../shared/icons/SettingsIcon";
import { SupportButton } from "../SupportButton";
import { TPopoverIds } from "../../../../app/state/popoverSlice/types";
import { TEntityInfo } from "../../../types/utility";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectUserArtifactGroup } from "../../../../features/Auth/redux/selectors";
import { AppNavLink } from "../../../../shared/components/AppNavLink";
import { ProfileButton } from "../../../../features/Modals/ProfileModal/components/ProfileButton";
import styles from "./styles.module.css";

interface Props {
  openPopover: (
    e: React.MouseEvent,
    id: TPopoverIds,
    info: TEntityInfo | null,
  ) => void;
}

export const HeaderActions = ({ openPopover }: Props) => {
  const artifacts = useAppSelector(selectUserArtifactGroup);
  const { t } = useTranslation();

  return (
    <div className={styles["login-container"]}>
      <SupportButton />
      <ProfileButton />
      {artifacts && (
        <AppNavLink
          activeClassName={styles.active}
          className={styles["header-link"]}
          to={"/artifacts"}
        >
          {t("header.artifacts")}
        </AppNavLink>
      )}
      <AppIconButton
        onClick={(e) => openPopover(e, "user_account_popover", null)}
      >
        <SettingsIcon width={24} height={24} />
      </AppIconButton>
    </div>
  );
};
